let sequence = 0;

export const createInitRequestId = (): string => {
  sequence += 1;

  return `init-${sequence}`;
};
